export default function generateConnectUrl() { 
  return`/file-manager/`
}
